import React from "react";

interface Props {
  show: boolean;
  title: string;
  message: string;
  actionLabel?: string;
  secondaryLabel?: string;
  onSecondary?: () => void;
  onClose: () => void;
}

const InfoModal: React.FC<Props> = ({
  show,
  title,
  message,
  actionLabel = "Mengerti",
  secondaryLabel,
  onSecondary,
  onClose,
}) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[10003] px-4">
      <div className="bg-white rounded-xl p-5 w-full max-w-sm shadow-lg text-center">
        <h2 className="text-lg font-semibold text-gray-800 mb-2">{title}</h2>
        <p className="text-sm text-gray-600 mb-5 leading-relaxed">{message}</p>
        <button
          onClick={onClose}
          className="w-full bg-teal-500 text-white rounded-lg py-2.5 text-sm font-semibold"
        >
          {actionLabel}
        </button>
        {secondaryLabel && (
          <button onClick={onSecondary ?? onClose} className="w-full text-gray-500 text-sm py-2 mt-1">
            {secondaryLabel}
          </button>
        )}
      </div>
    </div>
  );
};

export default InfoModal;
